export const L10N = {
  LABEL_BOOKING: { id: 'common.label.booking' },
  LABEL_CHOOSE_STAY: { id: 'core.label.choose_stay' },
  LABEL_CONFIRMATION: { id: 'common.label.confirmation' },
  LABEL_PAYMENT: { id: 'common.label.payment' },
  LABEL_PERSONAL_DETAILS: { id: 'core.label.personal_details' },
};
